import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["textContent"];
import { get, remove } from '@/api/system/mail';
import { useCommonDialog } from '@/component-create/utils/hooks';
import { MAIL_TYPE } from '@/constant/system/code';
import { isOnlyOne } from '@/utils/common';
import { deleteBox, toast } from '@/utils/message';
import { renderMailAdd } from './add';
import { renderMailEdit } from './edit';
import { renderMailSearchForm } from './search';
import { createTable } from './table';
import Contact from './Contact.vue';
import { renderSendForm } from './send';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Mail',
  setup(__props) {
    const searchRef = ref();
    const tableRef = ref();
    const mailAddFormRef = ref();
    const mailEditFormRef = ref();
    const mailSendFormRef = ref();
    const contactRef = ref();
    let searchData = {};
    let table;
    const mail = ref({
      mailSubject: '',
      mailContent: '',
      mailType: ''
    });
    let mailAddForm;
    let mailEditForm;
    let mailSendForm;
    const mailContentDialog = useCommonDialog('showMailContent');
    onMounted(() => {
      table = createTable(tableRef.value, {
        rowDelete,
        rowEdit,
        rowSend,
        rowShow
      }, {
        addFn,
        deleteFn,
        editFn,
        contactsFn
      });
      const search = renderMailSearchForm(searchRef.value);
      search.onSearch = formData => {
        searchData = formData;
        table.load(searchData);
      };
      search.onReset = () => {
        searchData = {};
        table.load(searchData);
      };
      mailAddForm = renderMailAdd(mailAddFormRef.value);
      mailAddForm.onSaveSuccess = () => {
        table.load(searchData);
      };
      mailEditForm = renderMailEdit(mailEditFormRef.value);
      mailEditForm.onSaveSuccess = () => {
        table.load(searchData);
      };
      mailSendForm = renderSendForm(mailSendFormRef.value);
    });
    function rowDelete(row) {
      deleteBox().then(() => {
        remove([row.id]).then(() => {
          toast.success('删除成功');
          table.load(searchData);
        });
      });
    }
    function rowEdit(row) {
      mailEditForm.open(row.id);
    }
    function rowSend(row) {
      mailSendForm.open(row.id);
    }
    function rowShow(row) {
      mailContentDialog.open();
      get(row.id).then(res => {
        mail.value = res.data;
      });
    }
    function addFn() {
      mailAddForm.open();
    }
    function deleteFn(rows) {
      if (rows.length === 0) {
        toast.warn('请至少选择一条数据');
      } else {
        remove(rows.map(i => i.id)).then(() => {
          toast.success('删除成功');
          table.load(searchData);
        });
      }
    }
    function editFn(row) {
      if (isOnlyOne(row)) {
        mailEditForm.open(row[0].id);
      }
    }
    function contactsFn() {
      contactRef.value?.open();
    }
    return (_ctx, _cache) => {
      const _component_ElFormItem = _resolveComponent("ElFormItem");
      const _component_ElForm = _resolveComponent("ElForm");
      const _component_XCommonDialog = _resolveComponent("XCommonDialog");
      const _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "search",
          ref_key: "searchRef",
          ref: searchRef
        }, null, 512), _createElementVNode("div", {
          class: "table",
          style: {
            "height": "100%"
          },
          ref_key: "tableRef",
          ref: tableRef
        }, null, 512), _createVNode(_component_XCommonDialog, {
          ref: "showMailContent",
          title: "邮件详情"
        }, {
          default: _withCtx(() => [_createVNode(_component_ElForm, null, {
            default: _withCtx(() => [_createVNode(_component_ElFormItem, {
              label: "主题"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(mail).mailSubject), 1)]),
              _: 1
            }), _createVNode(_component_ElFormItem, {
              label: "内容"
            }, {
              default: _withCtx(() => [_unref(mail).mailType === _unref(MAIL_TYPE).HTML.CODE ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: {
                  "overflow-y": "auto",
                  "width": "800px"
                },
                innerHTML: _unref(mail).mailContent
              }, null, 8, _hoisted_1)) : (_openBlock(), _createElementBlock("div", {
                key: 1,
                textContent: _toDisplayString(_unref(mail).mailContent)
              }, null, 8, _hoisted_2))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 512), _createVNode(Contact, {
          ref_key: "contactRef",
          ref: contactRef
        }, null, 512), _createElementVNode("div", {
          ref_key: "mailAddFormRef",
          ref: mailAddFormRef
        }, null, 512), _createElementVNode("div", {
          ref_key: "mailEditFormRef",
          ref: mailEditFormRef
        }, null, 512), _createElementVNode("div", {
          ref_key: "mailSendFormRef",
          ref: mailSendFormRef
        }, null, 512)]),
        _: 1
      });
    };
  }
});